import OrderItemsTypeList from './OrderItemsTypeList'

export default {
  list: OrderItemsTypeList,
}
